import { AfterViewInit, Component, Inject, inject, OnInit, signal, ViewChild } from '@angular/core';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { DashboardGetAdvisorsDataByBranchServiceV2 } from '../../dashboard-services/dashboard-get-advisors-data-by-branch/dashboard-get-advisors-data-by-branch-v2.service';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { HttpStatusCode } from 'axios';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { GrossRevenueByAdvisorsV2 } from '../../dashboard-interfaces/gross-revenue-by-advisors-v2.interface';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-gross-revenue-branch-advisors-v2',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './view-gross-revenue-branch-advisors-v2.dialog.html',
  styleUrl: './view-gross-revenue-branch-advisors-v2.dialog.scss'
})
export class ViewGrossRevenueBranchAdvisorsDialogV2 implements OnInit, AfterViewInit {

  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  private dashboardGetAdvisorsDataByBranchService = inject(DashboardGetAdvisorsDataByBranchServiceV2);

  private grossRevenueByAdvisorData: GrossRevenueByAdvisorsV2[] = [];
  protected grossRevenueByAdvisorTableDisplayColumn: string[] = ["repCode", "personName", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
  protected grossRevenueByAdvisorTableDataSource = new MatTableDataSource<GrossRevenueByAdvisorsV2>();

  grossRevenueByAdvisorTableFilterFc = new FormControl("");

  @ViewChild('grossRevenueByAdvisorTablePaginator')
  grossRevenueByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('grossRevenueByAdvisorTableSort')
  grossRevenueByAdvisorTableSort = new MatSort();

  protected branchName: string = "";
  protected targetYear: string = "";

  protected setSprinner = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public matData: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.branchName = this.matData.branchName;
    this.targetYear = this.matData.targetYear;
    
    await this.getDashboardDataByBranchAdvisors(this.branchName, this.targetYear);

    this.grossRevenueByAdvisorTableDataSource.data = this.grossRevenueByAdvisorData;
  }

  ngAfterViewInit(): void {
    this.grossRevenueByAdvisorTableDataSource.paginator = this.grossRevenueByAdvisorTablePaginator;
    this.grossRevenueByAdvisorTableDataSource.sort = this.grossRevenueByAdvisorTableSort;
  }

  private async getDashboardDataByBranchAdvisors(branchName: string, targetYear: string) {
    this.setSprinner.set(true);

    const responseData = await this.dashboardGetAdvisorsDataByBranchService
      .getDashboardGrossRevenueBranchwiseAdvisors(branchName, Number.parseInt(targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      const advisorData: any[] = responseData.data.responsedata;
      advisorData.forEach((advisorItem) => {
        this.grossRevenueByAdvisorData.push({
          repCode: advisorItem.piasRepCode.toString(),
          personName: advisorItem.agentRealName.toString() || advisorItem.agentPreferredName.toString(),
          branch: advisorItem.branch.toString(),
          lifeInsuranceYtd: advisorItem.grossRevenueTotLifeInsurance.toString(),
          investmentYtd: advisorItem.grossRevenueTotInvestment.toString(),
          generalInsuranceYtd: advisorItem.grossRevenueTotGi.toString(),
          feeAndReferralYtd: advisorItem.grossRevenueTotFeeAndReferral.toString(),
          totalGrossRevenueYtd: advisorItem.grossRevenueTot.toString(),
          userGroup: advisorItem.userGroup.toString()
        })
      });

      // this.grossRevenueByAdvisorData = this.grossRevenueByAdvisorData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected clearSearchField() {
    this.grossRevenueByAdvisorTableFilterFc.setValue('');
    this.__applyGrossRevenueByAdvisorDataFilter();
  }

  protected __applyGrossRevenueByAdvisorDataFilter() {
    let filterValue: string = this.grossRevenueByAdvisorTableFilterFc.value?.toString() || '';

    let tempGrossRevenueByAdvisorTableData: GrossRevenueByAdvisorsV2[] = [];

    if (filterValue) {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData.filter(grData =>
        grData.repCode.toLowerCase().includes(filterValue.toLowerCase())
        || grData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData;
    }

    this.grossRevenueByAdvisorTableDataSource.data = tempGrossRevenueByAdvisorTableData;
  }

}
